var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7939 6.1H10.6773V17.9H20.7939C21.291 17.9 21.6939 17.4971 21.6939 17V7C21.6939 6.50294 21.291 6.1 20.7939 6.1ZM4.79395 6.1H9.57726V17.9H4.79395C4.29689 17.9 3.89395 17.4971 3.89395 17V7C3.89395 6.50294 4.29689 6.1 4.79395 6.1ZM4.79395 5C3.68938 5 2.79395 5.89543 2.79395 7V17C2.79395 18.1046 3.68938 19 4.79395 19H20.7939C21.8985 19 22.7939 18.1046 22.7939 17V7C22.7939 5.89543 21.8985 5 20.7939 5H4.79395ZM5.79395 7.95C5.49019 7.95 5.24395 8.19624 5.24395 8.5C5.24395 8.80376 5.49019 9.05 5.79395 9.05H7.79395C8.0977 9.05 8.34395 8.80376 8.34395 8.5C8.34395 8.19624 8.0977 7.95 7.79395 7.95H5.79395ZM5.24395 10.8333C5.24395 10.5296 5.49019 10.2833 5.79395 10.2833H7.79395C8.0977 10.2833 8.34395 10.5296 8.34395 10.8333C8.34395 11.1371 8.0977 11.3833 7.79395 11.3833H5.79395C5.49019 11.3833 5.24395 11.1371 5.24395 10.8333ZM5.79395 12.6167C5.49019 12.6167 5.24395 12.8629 5.24395 13.1667C5.24395 13.4704 5.49019 13.7167 5.79395 13.7167H7.79395C8.0977 13.7167 8.34395 13.4704 8.34395 13.1667C8.34395 12.8629 8.0977 12.6167 7.79395 12.6167H5.79395Z",
    fill: "#35363A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebar);
export default __webpack_public_path__ + "static/media/sidebar.5cdf647a93d9696201354a60bffb2de2.svg";
export { ForwardRef as ReactComponent };